export const SUCCESS: string = "_SUCCESS";
export const FAILURE: string = "_FAILURE";
